import React, { FC, useState } from 'react';
import { DropResult } from 'react-beautiful-dnd';
import {
    DraggableWorksheetFormComponent,
    FormAnswerSelectedOption,
    FormElementGridCellAnswer,
    WorksheetElementAnswers,
} from '@packages/models/api';

import { WorksheetFormElementComponent, WorksheetFormElements } from './worksheet-form-elements';
import { View, StyleSheet } from 'react-native';
import WorksheetLabelAndTooltip from './worksheet-form-element-label';

export interface WorksheetFormElementRenderProps {
    item: DraggableWorksheetFormComponent;
    isMediaViewOnly?: boolean;
    readOnly?: boolean;
    preview?: boolean;
    isDraftLoading?: boolean;
    isSubmitLoading?: boolean;
    onAnswerChange?: (answer: WorksheetElementAnswers) => void;
    handleDragEnd: (result: DropResult) => void;
    onEditClick?(item: DraggableWorksheetFormComponent): void;
    onDeleteClick?(item: DraggableWorksheetFormComponent): void;
    onCopyClick?(item: DraggableWorksheetFormComponent): void;
    onChildDrag?(item: DraggableWorksheetFormComponent): void;
    handleIsValid?: (valid: boolean) => void;
    handleAnswerChange?: (formelementId: string, selectedAnswer: FormAnswerSelectedOption[]) => void;
    handleGridCellAnswerChange?: (formElementId: string, gridCellAnswers: FormElementGridCellAnswer[]) => void;
    getCurrentAnswerByElementId?: (id: string) => WorksheetElementAnswers;
}

interface WorksheetFormElementProps extends WorksheetFormElementRenderProps {}

export const BaseWorksheetFormElement: FC<WorksheetFormElementProps> = ({
    isMediaViewOnly,
    item,
    readOnly,
    preview,
    onAnswerChange,
    handleDragEnd,
    onEditClick,
    onChildDrag,
    onCopyClick,
    onDeleteClick,
    handleIsValid,
    handleAnswerChange,
    handleGridCellAnswerChange,
    getCurrentAnswerByElementId,
    isDraftLoading,
    isSubmitLoading,
}) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const { formElementTypeId, required, formElementTooltip, formElementLabel, formElementDescription } = item;
    const FormElementComponent: WorksheetFormElementComponent = WorksheetFormElements[item.formElementTypeId];
    if (!FormElementComponent) {
        return null;
    }

    return (
        <View style={styles.formSection}>
            <WorksheetLabelAndTooltip
                required={required}
                tooltip={formElementTooltip}
                formElementLabel={formElementLabel}
                preview={preview}
                formElementDescription={formElementDescription}
                setIsExpanded={setIsExpanded}
                isExpanded={isExpanded}
                formElementTypeId={formElementTypeId}
            />
            <View style={[!isExpanded && styles.hidden]}>
                <FormElementComponent
                    isMediaViewOnly={isMediaViewOnly}
                    item={item}
                    handleDragEnd={handleDragEnd}
                    onChildDrag={onChildDrag}
                    onCopyClick={onCopyClick}
                    onDeleteClick={onDeleteClick}
                    onEditClick={onEditClick}
                    readOnly={readOnly}
                    preview={preview}
                    onAnswerChange={onAnswerChange}
                    handleIsValid={handleIsValid}
                    handleAnswerChange={handleAnswerChange}
                    handleGridCellAnswerChange={handleGridCellAnswerChange}
                    isDraftLoading={isDraftLoading}
                    isSubmitLoading={isSubmitLoading}
                    getCurrentAnswerByElementId={getCurrentAnswerByElementId}
                    {...item}
                />
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    formSection: {
        paddingBottom: 24,
        zIndex: 'unset' as unknown as number,
    },
    hidden: {
        display: 'none',
    },
});
